// eslint-disable-next-line import/no-extraneous-dependencies
import useEmblaCarousel from "embla-carousel-react"
import {useCallback, useEffect} from "react"
import {useDispatch} from "react-redux"
import {breakpoints} from "@next/themes"

import {Action} from "@reduxjs/toolkit"
import {setAnimateFavouriteIcon, setSelectedColourwayAction} from "../../ducks/productSummary"
import useMediaQuery from "../useMediaQuery"

const useCarousel = ({textAlignment, colourways, itemNumber}) => {
    const dispatch = useDispatch()
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: false,
        align: "start",
        watchDrag: !useMediaQuery(`(min-width:${breakpoints.values.lg}px)`),
        containScroll: false,
        direction: textAlignment === "ltr" ? "ltr" : "rtl",
        duration: 10,
        skipSnaps: true,
    })

    const [thumbsEmblaRef, thumbsEmblaApi] = useEmblaCarousel({
        loop: false,
        align: "start",
        watchDrag: true,
        containScroll: "keepSnaps",
        direction: textAlignment === "ltr" ? "ltr" : "rtl",
        skipSnaps: true,
        duration: 10,
    })

    const slideIndex = useCallback((index: number) => emblaApi?.scrollTo(index), [emblaApi])

    const thumbsSlideIndex = useCallback((index: number) => thumbsEmblaApi?.scrollTo(index), [thumbsEmblaApi])

    const handleSetSelectedColourway = (colourwayItemNumber: string) => {
        dispatch<Action>(
            setSelectedColourwayAction({
                colourwayItemNumber,
                itemNumber,
            }),
        )
        dispatch<Action>(
            setAnimateFavouriteIcon({
                itemNumber,
                animateFavouriteIcon: false,
            }),
        )
    }

    useEffect(() => {
        // window.requestIdleCallback(() => {
        const handleProductSlideChange = (actualIndex: number) => {
            const currentSlide = colourways[actualIndex] || 0
            if (currentSlide) {
                handleSetSelectedColourway(currentSlide.id)
            }
        }

        if (emblaApi) {
            const handleSelect = () => {
                const selectedIndex = emblaApi.selectedScrollSnap() % colourways.length
                handleProductSlideChange(selectedIndex)
                if (thumbsEmblaApi) {
                    thumbsEmblaApi.scrollTo(selectedIndex)
                }
            }
            handleSelect()
            emblaApi.on("select", handleSelect)
            window.addEventListener("resize", handleSelect)
        }
        // })
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, react-hooks/exhaustive-deps
    }, [emblaApi, colourways.length, itemNumber, thumbsEmblaApi])

    return {
        emblaRef,
        emblaApi,
        slideIndex,
        thumbsEmblaRef,
        thumbsEmblaApi,
        thumbsSlideIndex,
    }
}

export default useCarousel
